import React, { DispatchWithoutAction, forwardRef, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

import { ISVGPersonalProps } from 'types/svg';
import { Label } from 'components/atoms/label';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './input.module.css';

export interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  inputType?: string;
  icon?: ISVGPersonalProps;
  error?: string;
  reset?: DispatchWithoutAction;
}

const DEFAULT_ICON_SIZE = { width: 24, height: 24 };

const Input = forwardRef<HTMLInputElement, IInputProps>((props, ref) => {
  const { className, value, required, label, inputType = 'text', icon, error, reset, ...rest } = props;

  const wrapperClassname = classNames(styles.wrapper, className, { [styles.withReset]: !!reset });
  const inputClassname = classNames(styles.input, { [styles.invalid]: !!error });

  return (
    <div className={wrapperClassname}>
      {!!label && <Label label={label} required={required} />}
      <div className={styles.field}>
        {!!icon && <SvgWrapper className={styles.icon} details={icon} {...DEFAULT_ICON_SIZE} />}
        <input ref={ref} className={inputClassname} value={value} aria-label="input" type={inputType} {...rest} />
        {!!reset && value && (
          <span className={styles.resetIcon} onClick={reset}>
            x
          </span>
        )}
        {!!error && <span className={styles.error}>{error}</span>}
      </div>
    </div>
  );
});

Input.displayName = 'input';

export default Input;
